import React from 'react';
import './LeftNav.css';
import SectionHeadings from './SectionHeadings';

interface LeftNavProps {
  selectedRole: string | null;
  onRoleSelect: (role: string | null) => void;
  onResetFilters: () => void;
}

const LeftNav: React.FC<LeftNavProps> = ({ selectedRole, onRoleSelect, onResetFilters }) => {
  return (
    <nav className="left-nav">
      <div className="nav-header">
        <h2 className="nav-title">
          <span className="nav-title-primary">MI Revenue</span>
          <br />
          <span className="nav-title-secondary">Analytics Platform</span>
        </h2>
      </div>
      <SectionHeadings 
        selectedRole={selectedRole} 
        onRoleSelect={onRoleSelect}
        onResetFilters={onResetFilters}
      />
    </nav>
  );
};

export default LeftNav;